import { t } from "@lingui/macro";
import { motion } from "framer-motion";

const stats = () => [
  { value: "6M+", label: t`Job seekers trust Stylion` },
  { value: "96%", label: t`ATS pass rate` },
  { value: "2 min", label: t`Average resume build time` },
  { value: "11", label: t`Specialized AI agents` },
];

export const TrustBarSection = () => {
  const items = stats();

  return (
    <section
      id="trust-bar"
      className="relative border-y border-white/5 bg-[#050505]/50 py-10 backdrop-blur-md"
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 gap-6 lg:grid-cols-4 lg:gap-8">
          {items.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.06 }}
              className="text-center"
            >
              <div className="font-sans text-3xl font-bold tracking-tighter text-white sm:text-4xl">
                {stat.value}
              </div>
              <div className="mt-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-white/50">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
